import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

import Spinner from 'spinner';
import Input from 'form/input';
import {UniversalSearchWrapper, List, EmptyList} from 'components/common';
import {ButtonDefault, LinkInfo} from 'components/buttons';
import Pagination from 'pagination';

import {loadInstitutionPersonalById, searchInstitutionPersonal} from 'redux/actions/portal/institutions';

const LinkInfoButton = styled(LinkInfo)`
  margin-left: 10px;
`

const mapStateToProps = (state) => ({
  personal: state.institutions.get('institutionPersonal'),
  isFetching: state.institutions.get('institutionsIsLoading')
}); 

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id, offset) => dispatch(loadInstitutionPersonalById(id, 12, offset)),
  onSearch: (id, name) => dispatch(searchInstitutionPersonal(id, name))
});

class SubordinatePersonal extends Component {

  constructor(props) {
    super(props); 

    this.state = {
      name: ""
    }

    this.changeSearchName = this.changeSearchName.bind(this);
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }

  componentWillMount() {
    const page = this.props.match.params.page || 1;
    const offset = 12 * (page - 1);
    this.props.onLoad(this.props.match.params.id, offset)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
        const page = nextProps.match.params.page || 1;
        const offset = 12 * (page - 1);
      this.props.onLoad(nextProps.match.params.id, offset)
    }
  }

  render() {


    if (this.props.personal === undefined || (!this.props.personal.get('results'))) {
      return (
          <Spinner/>

      );
    }

    if (this.props.personal.get('results').size === 0) {
      return(
        <div>
            <UniversalSearchWrapper onSubmit={(event) => {
          event.preventDefault();
          this.props.onSearch(this.props.match.params.id, this.state.name)
        }}>
          <Input
            block
            placeholder="Введіть прізвище чи посаду"
            label="Пошук за прізвищем чи посадою"
            value={this.state.name}
            onChange={this.changeSearchName}
          />
          <ButtonDefault type="submit" value="Пошук" />
          <LinkInfo style={{height: "47px", marginTop: "25px"}} to={{
            pathname: `/admin/institutions/${this.props.match.params.id}/add-personal`,
            state: { institutionTitle: this.props.institutionTitle }
          }} >Додати</LinkInfo>
        </UniversalSearchWrapper>
        <EmptyList>
            <h5>Інформація про персонал відсутня </h5>
      </EmptyList>
        </div>
      )
    }

    return(
      <div>
        <UniversalSearchWrapper onSubmit={(event) => {
          event.preventDefault();
          this.props.onSearch(this.props.match.params.id, this.state.name)
        }}>
          <Input
            block
            placeholder="Введіть прізвище чи посаду"
            label="Пошук за прізвищем чи посадою"
            value={this.state.name}
            onChange={this.changeSearchName}
          />
          <ButtonDefault type="submit" value="Пошук" />
          <LinkInfoButton style={{height: "47px", marginTop: "25px"}} to={{
            pathname: `/admin/institutions/${this.props.match.params.id}/add-personal`,
            state: { institutionTitle: this.props.institutionTitle }
          }} >Додати</LinkInfoButton>
        </UniversalSearchWrapper>

        {this.props.personal.get('results').size > 0 ? (
          <List>
              {this.props.personal.get('results').map((item, i) => (
              <li key={i}>
                  <Link to={`/admin/institutions/${this.props.match.params.id}/personal/${item.get('id')}`}>
                    <h5>{item.getIn(['user_data', 'last_name'])} {item.getIn(['user_data', 'first_name'])} {item.getIn(['user_data', 'middle_name'])}</h5>
                    <p><span>Посада: </span>{item.get('position_title')}</p>
                  </Link>
              </li>
              ))}
          </List>
        ): (
          <h5>Підпорядкований персонал відсутній</h5>
        )}
        <Pagination counts={this.props.personal.get('count')} path={`/admin/institutions/detail/${this.props.match.params.id}/subordinate-personal/`} matched={this.props.match.params.page} limits={12} />

      </div>
    )
  }
}



export default connect(mapStateToProps, mapDispatchToProps)(SubordinatePersonal);



// WEBPACK FOOTER //
// ./src/admin/institutions/subordinate-personal.js